// Auto-generated by webpack.mix.js — do not edit
// Aggregates all PHP translation files for locale it_IT_ai
const req = require.context('../../../../../lang/it_IT_ai', false, /\.php$/);
const messages = {};
req.keys().forEach(key => {
  const name = key.replace('./','').replace('.php','');
  messages['it_IT_ai.' + name] = req(key);
});
// If Lang is available in window, initialize or update it
if (typeof window !== 'undefined' && window.Lang) {
  if (window.lang && typeof window.lang.setMessages === 'function') {
    window.lang.setMessages(messages);
  } else {
    window.lang = new window.Lang({messages});
  }
}
export default messages;
